import { DocumentAddItemsType } from "@/api/product/model/documentAddModel"
import { DocumentData } from '@/api/model/documentModel'

export interface State {
  modalDocumentAddActived: boolean,
  modalDocumentAddCancelActived: boolean,
  modalDocumentAddSubmitActived: boolean,
  documentAddItems: DocumentAddItemsType,
  remarkCheckError: string,
  hasErr: boolean,
  addOk: boolean,
  documentDatas: DocumentData[]
}

const setupData = {
  productID: 0,
  productCode: '',
  productName: '',
  productEnName: '',
  documentType: '',
  issuerProductCode: '',
  remark: '',
  fileList: [],
}

const state = (): State => ({
  modalDocumentAddActived: false,
  modalDocumentAddCancelActived: false,
  modalDocumentAddSubmitActived: false,
  documentAddItems: setupData,
  remarkCheckError: '',
  hasErr: false,
  addOk: false,
  documentDatas: [],
})

export default state